<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">代运营管理</span>
      </div>

      <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
        <!-- 待接收 Tab -->
        <el-tab-pane label="待接收" name="pending">
          <div class="search-bar">
            <el-form :inline="true" size="small">
              <el-form-item label="关键词">
                <el-input v-model="pendingQuery.keyword" placeholder="项目名/客户名" clearable @keyup.enter.native="getPendingList" style="width:200px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getPendingList(true)">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="pendingList" border height="calc(100vh - 320px)">
            <el-table-column label="序号" type="index" width="50px" align="center" fixed="left"></el-table-column>
            <el-table-column label="项目" min-width="200px">
              <template slot-scope="scope">
                <div class="bold">{{ scope.row.project && scope.row.project.projectName }}</div>
                <div class="text-content">{{ scope.row.project && scope.row.project.customerName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="招商专员" width="100px">
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.project && scope.row.project.signerName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="套餐类型" prop="packageType" width="120px">
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.packageType || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="评估单量" min-width="180px">
              <template slot-scope="scope">
                <el-tag v-for="v in scope.row.estimatedVolumes" :key="v.platform" size="mini" style="margin-right:5px">
                  {{ platformName(v.platform) }}: {{ v.volume }}
                </el-tag>
                <span v-if="!scope.row.estimatedVolumes || scope.row.estimatedVolumes.length === 0" class="text-content">-</span>
              </template>
            </el-table-column>
            <el-table-column label="移交时间" width="180px">
              <template slot-scope="scope">{{ scope.row.handoverAt | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="操作" width="120px" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="openAcceptDialog(scope.row)">接收</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            style="margin-top:10px;"
            @current-change="pendingPageChange"
            :current-page="pendingQuery.pagenum"
            :page-size="pendingQuery.pagesize"
            layout="total, prev, pager, next"
            :total="pendingTotal">
          </el-pagination>
        </el-tab-pane>

        <!-- 运营中 Tab -->
        <el-tab-pane label="运营中" name="active">
          <div class="search-bar">
            <el-form :inline="true" size="small">
              <el-form-item label="关键词">
                <el-input v-model="activeQuery.keyword" placeholder="项目名/客户名" clearable @keyup.enter.native="getActiveList" style="width:200px"></el-input>
              </el-form-item>
              <el-form-item label="运营师">
                <el-select v-model="activeQuery.operatorId" clearable placeholder="请选择" @change="getActiveList" style="width:120px">
                  <el-option v-for="item in operatorOptions" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getActiveList(true)">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="activeList" border height="calc(100vh - 320px)">
            <el-table-column label="序号" type="index" width="50px" align="center" fixed="left"></el-table-column>
            <el-table-column label="项目" min-width="200px">
              <template slot-scope="scope">
                <div class="bold">{{ scope.row.project && scope.row.project.projectName }}</div>
                <div class="text-content">{{ scope.row.project && scope.row.project.customerName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="套餐类型" width="120px">
              <template slot-scope="scope">
                <span class="text">{{ scope.row.packageType || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="招商专员" width="100px">
              <template slot-scope="scope">
                <span class="text">{{ scope.row.project && scope.row.project.signerName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="负责人" width="100px">
              <template slot-scope="scope">
                <span class="text">{{ scope.row.operatorName || '-' }}</span>
              </template>
            </el-table-column>

            <el-table-column label="服务期" width="200px">
              <template slot-scope="scope">
                <div class="text">{{ scope.row.serviceStartDate | date }} 至 {{ scope.row.serviceEndDate | date }}</div>
              </template>
            </el-table-column>

            <el-table-column label="平台/店铺" min-width="240px">
              <template slot-scope="scope">
                <span v-for="p in scope.row.platforms" :key="p._id" style="margin-right: 5px;">
                  <el-tag size="small">{{ platformName(p.platform) }}</el-tag>
                  <!-- {{ p.code }}<span v-if="p.storeName"> ({{ p.storeName }})</span> -->
                </span>
                <span v-if="!scope.row.platforms || scope.row.platforms.length === 0" class="text">-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="240px" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="openDetailDialog(scope.row)">详情</el-button>
                <el-button type="warning" plain size="mini" @click="openEditDialog(scope.row)">修改</el-button>
                <el-button type="danger" plain size="mini" @click="confirmMarkExpired(scope.row)">标记到期</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            style="margin-top:10px;"
            @current-change="activePageChange"
            :current-page="activeQuery.pagenum"
            :page-size="activeQuery.pagesize"
            layout="total, prev, pager, next"
            :total="activeTotal">
          </el-pagination>
        </el-tab-pane>

        <!-- 已到期 Tab（EXPIRED：自然到期或被续签覆盖；可再续签） -->
        <el-tab-pane label="已到期" name="expired">
          <div class="search-bar">
            <el-form :inline="true" size="small">
              <el-form-item label="关键词">
                <el-input v-model="expiredQuery.keyword" placeholder="项目名/客户名" clearable @keyup.enter.native="getExpiredList" style="width:200px"></el-input>
              </el-form-item>
              <el-form-item label="运营师">
                <el-select v-model="expiredQuery.operatorId" clearable placeholder="请选择" @change="getExpiredList" style="width:120px">
                  <el-option v-for="item in operatorOptions" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getExpiredList(true)">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="expiredList" border height="calc(100vh - 320px)">
            <el-table-column label="序号" type="index" width="50px" align="center" fixed="left"></el-table-column>
            <el-table-column label="项目" min-width="200px">
              <template slot-scope="scope">
                <div class="bold">{{ scope.row.project && scope.row.project.projectName }}</div>
                <div class="text-content">{{ scope.row.project && scope.row.project.customerName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="套餐类型" width="120px">
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.packageType || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="招商专员" width="100px">
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.project && scope.row.project.signerName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="负责人" width="100px">
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.operatorName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="平台/店铺" min-width="200px">
              <template slot-scope="scope">
                <span v-for="p in scope.row.platforms" :key="p._id" style="margin-right: 5px;">
                  <el-tag size="small">{{ platformName(p.platform) }}</el-tag>
                </span>
                <span v-if="!scope.row.platforms || scope.row.platforms.length === 0" class="text-content">-</span>
              </template>
            </el-table-column>
            <el-table-column label="服务期" width="200px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.serviceStartDate | date }} 至 {{ scope.row.serviceEndDate | date }}</div>
              </template>
            </el-table-column>
            <el-table-column label="到期信息" width="200px">
              <template slot-scope="scope">
                <div class="text-content">服务结束：{{ scope.row.serviceEndDate | date }}</div>
                <div v-if="scope.row.actualEndDate" class="text-detail">被续签覆盖（{{ scope.row.actualEndDate | date }}）</div>
                <div v-else class="text-detail">自然到期（可再续签）</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180px" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="openDetailDialog(scope.row)">详情</el-button>
                <!-- 延期仅对自然到期开放（独立权限"延期"，无权限者点击后端拒绝） -->
                <el-button v-if="!scope.row.actualEndDate" type="warning" plain size="mini" @click="openExtendDialog(scope.row)">延期</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            style="margin-top:10px;"
            @current-change="expiredPageChange"
            :current-page="expiredQuery.pagenum"
            :page-size="expiredQuery.pagesize"
            layout="total, prev, pager, next"
            :total="expiredTotal">
          </el-pagination>
        </el-tab-pane>

        <!-- 已解约 Tab -->
        <el-tab-pane label="已解约" name="terminated">
          <div class="search-bar">
            <el-form :inline="true" size="small">
              <el-form-item label="关键词">
                <el-input v-model="terminatedQuery.keyword" placeholder="项目名/客户名" clearable @keyup.enter.native="getTerminatedList" style="width:200px"></el-input>
              </el-form-item>
              <el-form-item label="运营师">
                <el-select v-model="terminatedQuery.operatorId" clearable placeholder="请选择" @change="getTerminatedList" style="width:120px">
                  <el-option v-for="item in operatorOptions" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getTerminatedList(true)">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="terminatedList" border height="calc(100vh - 320px)">
            <el-table-column label="序号" type="index" width="50px" align="center" fixed="left"></el-table-column>
            <el-table-column label="项目" min-width="200px">
              <template slot-scope="scope">
                <div class="bold">{{ scope.row.project && scope.row.project.projectName }}</div>
                <div class="text-content">{{ scope.row.project && scope.row.project.customerName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="套餐类型" width="120px">
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.packageType || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="招商专员" width="100px">
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.project && scope.row.project.signerName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="负责人" width="100px">
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.operatorName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="平台/店铺" min-width="240px">
              <template slot-scope="scope">
                <span v-for="p in scope.row.platforms" :key="p._id" style="margin-right: 5px;">
                  <el-tag size="small">{{ platformName(p.platform) }}</el-tag>
                </span>
                <span v-if="!scope.row.platforms || scope.row.platforms.length === 0" class="text-content">-</span>
              </template>
            </el-table-column>
            <el-table-column label="服务期" width="200px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.serviceStartDate | date }} 至 {{ scope.row.serviceEndDate | date }}</div>
              </template>
            </el-table-column>
            <el-table-column label="解约时间" width="160px">
              <template slot-scope="scope">{{ scope.row.terminatedAt | dateFormat }}</template>
            </el-table-column>
            <el-table-column label="操作" width="100px" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="openDetailDialog(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            style="margin-top:10px;"
            @current-change="terminatedPageChange"
            :current-page="terminatedQuery.pagenum"
            :page-size="terminatedQuery.pagesize"
            layout="total, prev, pager, next"
            :total="terminatedTotal">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 接收弹窗 -->
    <el-dialog title="接收代运营项目" :visible.sync="acceptDialogVisible" width="720px" :close-on-click-modal="false">
      <el-form :model="acceptForm" label-width="110px" size="small">
        <el-form-item label="项目">
          <span class="bold">{{ acceptForm.projectName }}</span>
        </el-form-item>
        <el-form-item label="套餐类型">
          <el-input v-model="acceptForm.packageType" placeholder="运营套餐类型" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="服务时间" required>
          <el-date-picker
            v-model="acceptForm.serviceDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:380px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="接收运营师" required>
          <el-select v-model="acceptForm.operatorId" filterable placeholder="请选择" style="width:200px" @change="onOperatorChange">
            <el-option v-for="item in operatorOptions" :key="item._id" :label="item.name" :value="item._id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企微群">
          <el-select
            v-model="acceptForm.conversationId"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="输入群名称搜索（选填）"
            :remote-method="searchGroups"
            :loading="groupLoading"
            style="width:100%">
            <el-option
              v-for="item in groupOptions"
              :key="item.conversation_id"
              :label="`${item.nickname}（${item.total}人）`"
              :value="item.conversation_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-divider>各平台店铺信息</el-divider>
        <el-form-item v-for="(p, idx) in acceptForm.platforms" :key="idx" :label="platformName(p.platform)">
          <el-input v-model="p.code" placeholder="店铺ID" style="width:180px"></el-input>
          <el-input v-model="p.storeName" placeholder="店铺名称" style="width:180px;margin-left:8px"></el-input>
          <el-input-number v-model="p.targetVolume" :min="0" placeholder="单量" style="width:140px;margin-left:8px"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="acceptDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAccept">确认接收</el-button>
      </div>
    </el-dialog>

    <!-- 修改弹窗 -->
    <el-dialog title="修改代运营详情" :visible.sync="editDialogVisible" width="720px" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="110px" size="small">
        <el-form-item label="项目">
          <span class="bold">{{ editForm.projectName }}</span>
        </el-form-item>
        <el-form-item label="套餐类型">
          <el-input v-model="editForm.packageType" placeholder="运营套餐类型" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="服务时间">
          <el-date-picker
            v-model="editForm.serviceDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:380px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="运营师">
          <el-select v-model="editForm.operatorId" filterable placeholder="不修改请保持原样" style="width:200px" @change="onEditOperatorChange">
            <el-option v-for="item in operatorOptions" :key="item._id" :label="item.name" :value="item._id"></el-option>
          </el-select>
          <span v-if="editForm.operatorName" class="text-content" style="margin-left:8px;">当前：{{ editForm.operatorName }}</span>
        </el-form-item>
        <el-divider>各平台店铺信息</el-divider>
        <el-form-item v-for="(p, idx) in editForm.platforms" :key="idx" :label="platformName(p.platform)">
          <el-input v-model="p.code" placeholder="店铺ID" style="width:180px"></el-input>
          <el-input v-model="p.storeName" placeholder="店铺名称" style="width:180px;margin-left:8px"></el-input>
          <el-input-number v-model="p.targetVolume" :min="0" placeholder="单量" style="width:140px;margin-left:8px"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确认修改</el-button>
      </div>
    </el-dialog>

    <!-- 延期弹窗 -->
    <el-dialog title="服务期延期" :visible.sync="extendDialogVisible" width="560px" :close-on-click-modal="false">
      <el-form :model="extendForm" label-width="110px" size="small">
        <el-form-item label="项目">
          <span class="bold">{{ extendForm.projectName }}</span>
        </el-form-item>
        <el-form-item label="当前服务期">
          <span class="text-content">{{ extendForm.serviceStartDate | date }} 至 {{ extendForm.serviceEndDate | date }}（已到期）</span>
        </el-form-item>
        <el-form-item label="新结束日期" required>
          <el-date-picker
            v-model="extendForm.newEndDate"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="extendDateOptions"
            placeholder="延期后的服务结束日期"
            style="width:260px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="延期原因" required>
          <el-input v-model="extendForm.reason" type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请填写延期原因（如：客户已确认续签，等待打款）"></el-input>
        </el-form-item>
      </el-form>
      <div class="text-content" style="margin-left:110px;">延期后服务期恢复为"服务中"：门店重新上线、平台恢复采集、负责人恢复</div>
      <div slot="footer">
        <el-button @click="extendDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="extendSaving" @click="submitExtend">确认延期</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="代运营详情" :visible.sync="detailDialogVisible" width="760px">
      <div v-if="detailData">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="项目">{{ detailData.project && detailData.project.projectName }}</el-descriptions-item>
          <el-descriptions-item label="客户">{{ detailData.project && detailData.project.customerName }}</el-descriptions-item>
          <el-descriptions-item label="套餐类型">{{ detailData.term.packageType || '-' }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ termStatusName(detailData.term.status) }}</el-descriptions-item>
          <el-descriptions-item label="服务开始">{{ detailData.term.serviceStartDate | date }}</el-descriptions-item>
          <el-descriptions-item label="服务结束">{{ detailData.term.serviceEndDate | date }}</el-descriptions-item>
          <el-descriptions-item label="接收运营师">{{ detailData.currentOperator ? detailData.currentOperator.employeeName : '-' }}</el-descriptions-item>
          <el-descriptions-item label="接收时间">{{ detailData.term.acceptedAt | dateFormat }}</el-descriptions-item>
        </el-descriptions>
        <h4 style="margin-top:20px;margin-bottom:8px;">平台店铺</h4>
        <el-table :data="detailData.platforms" border size="small">
          <el-table-column label="平台" width="100px">
            <template slot-scope="scope">{{ platformName(scope.row.platform) }}</template>
          </el-table-column>
          <el-table-column label="店铺ID" prop="code"></el-table-column>
          <el-table-column label="店铺名称" prop="storeName"></el-table-column>
          <el-table-column label="目标单量" prop="targetVolume" width="100px"></el-table-column>
        </el-table>

        <!-- 历史服务期时间线：该项目全部期次，当前查看期高亮 -->
        <h4 style="margin-top:20px;margin-bottom:8px;">历史服务期（共 {{ (detailData.terms || []).length }} 期）</h4>
        <el-table :data="detailData.terms || []" border size="small" :row-class-name="termRowClass">
          <el-table-column label="期次" width="70px" align="center">
            <template slot-scope="scope">第{{ scope.row.termNo }}期</template>
          </el-table-column>
          <el-table-column label="状态" width="90px" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="termStatusTagType(scope.row.status)">{{ termStatusName(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="服务期" width="200px">
            <template slot-scope="scope">
              <span v-if="scope.row.serviceStartDate">{{ scope.row.serviceStartDate | date }} 至 {{ scope.row.serviceEndDate | date }}</span>
              <span v-else>待接收</span>
            </template>
          </el-table-column>
          <el-table-column label="结束说明" min-width="160px">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 'EXPIRED' && scope.row.actualEndDate">被续签覆盖（{{ scope.row.actualEndDate | date }}）</span>
              <span v-else-if="scope.row.status === 'EXPIRED'">自然到期</span>
              <span v-else-if="scope.row.status === 'TERMINATED' && scope.row.terminatedAt">解约（{{ scope.row.terminatedAt | date }}）</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="来源" width="70px" align="center">
            <template slot-scope="scope">{{ scope.row.source === 'initial' ? '初始' : '续签' }}</template>
          </el-table-column>
          <el-table-column label="接收运营师" width="100px">
            <template slot-scope="scope">{{ scope.row.acceptedByName || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeTab: 'pending',
      pendingList: [],
      pendingTotal: 0,
      pendingQuery: { keyword: '', pagenum: 1, pagesize: 20 },
      activeList: [],
      activeTotal: 0,
      activeQuery: { keyword: '', operatorId: '', pagenum: 1, pagesize: 20 },
      terminatedList: [],
      terminatedTotal: 0,
      terminatedQuery: { keyword: '', operatorId: '', pagenum: 1, pagesize: 20 },
      expiredList: [],
      expiredTotal: 0,
      expiredQuery: { keyword: '', operatorId: '', pagenum: 1, pagesize: 20 },
      employeeList: [],
      groupOptions: [],
      groupLoading: false,
      acceptDialogVisible: false,
      acceptForm: this.emptyForm(),
      editDialogVisible: false,
      editForm: this.emptyForm(),
      extendDialogVisible: false,
      extendSaving: false,
      extendForm: this.emptyExtendForm(),
      extendDateOptions: {
        disabledDate (time) { return time.getTime() < Date.now() - 24 * 60 * 60 * 1000 }
      },
      detailDialogVisible: false,
      detailData: null
    }
  },
  computed: {
    // 运营师选项：与店铺管理 Dianpu.vue 保持一致
    operatorOptions () {
      return this.employeeList.filter(e => /运营师|运营主管|建店专员/.test(e.job))
    }
  },
  created () {
    this.getOperatorList()
    this.getPendingList()
  },
  methods: {
    platformName (p) {
      return { meituan: '美团', eleme: '饿了么', jd: '京东' }[p] || p
    },
    termStatusName (s) {
      return { PENDING: '待接收', ACTIVE: '服务中', TERMINATED: '已解约', EXPIRED: '已到期' }[s] || s
    },
    termStatusTagType (s) {
      return { PENDING: 'warning', ACTIVE: 'success', TERMINATED: 'danger', EXPIRED: 'info' }[s] || ''
    },
    termRowClass ({ row }) {
      return this.detailData && this.detailData.term && row._id === this.detailData.term._id
        ? 'current-term-row'
        : ''
    },
    emptyForm () {
      return {
        termId: '',
        projectName: '',
        packageType: '',
        serviceDateRange: [],
        operatorId: '',
        operatorName: '',
        conversationId: '',
        platforms: [
          { platform: 'meituan', code: '', storeName: '', targetVolume: null },
          { platform: 'eleme', code: '', storeName: '', targetVolume: null },
          { platform: 'jd', code: '', storeName: '', targetVolume: null }
        ]
      }
    },
    emptyExtendForm () {
      return {
        termId: '',
        projectName: '',
        serviceStartDate: null,
        serviceEndDate: null,
        newEndDate: '',
        reason: ''
      }
    },
    handleTabClick (tab) {
      if (tab.name === 'pending') this.getPendingList()
      else if (tab.name === 'active') this.getActiveList()
      else if (tab.name === 'expired') this.getExpiredList()
      else if (tab.name === 'terminated') this.getTerminatedList()
    },
    async getOperatorList () {
      const { data: res } = await this.$http.get('yunying/employees/list')
      if (res.meta.status === 200) this.employeeList = res.data || []
    },
    async searchGroups (query) {
      this.groupLoading = true
      try {
        const { data: res } = await this.$http.get('proxy/search-groups', { params: { keyword: query } })
        if (res.meta.status === 200) this.groupOptions = res.data.list || []
      } catch (e) {
        // 忽略，保留现有 options
      } finally {
        this.groupLoading = false
      }
    },
    async getPendingList (first = false) {
      if (first) this.pendingQuery.pagenum = 1
      const { data: res } = await this.$http.get('proxy/pending', { params: this.pendingQuery })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.pendingList = res.data.list
      this.pendingTotal = res.data.total
    },
    pendingPageChange (p) { this.pendingQuery.pagenum = p; this.getPendingList() },
    async getActiveList (first = false) {
      if (first) this.activeQuery.pagenum = 1
      const { data: res } = await this.$http.get('proxy/active', { params: this.activeQuery })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.activeList = res.data.list
      this.activeTotal = res.data.total
    },
    activePageChange (p) { this.activeQuery.pagenum = p; this.getActiveList() },
    async getTerminatedList (first = false) {
      if (first) this.terminatedQuery.pagenum = 1
      const params = { ...this.terminatedQuery, status: 'TERMINATED' }
      const { data: res } = await this.$http.get('proxy/active', { params })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.terminatedList = res.data.list
      this.terminatedTotal = res.data.total
    },
    terminatedPageChange (p) { this.terminatedQuery.pagenum = p; this.getTerminatedList() },
    async getExpiredList (first = false) {
      if (first) this.expiredQuery.pagenum = 1
      const params = { ...this.expiredQuery, status: 'EXPIRED' }
      const { data: res } = await this.$http.get('proxy/active', { params })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.expiredList = res.data.list
      this.expiredTotal = res.data.total
    },
    expiredPageChange (p) { this.expiredQuery.pagenum = p; this.getExpiredList() },
    // 标记服务到期（运营中 tab 操作；term → EXPIRED + 门店下线/平台停采集/负责人收回）
    confirmMarkExpired (row) {
      const name = row.project && row.project.projectName
      this.$confirm(`确认将「${name}」当前服务期标记为服务到期？门店将下线、平台停采集、负责人收回，客户续签后可再接收恢复`, '标记到期', {
        confirmButtonText: '确认到期',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await this.$http.put(`proxy/mark-expired/${row._id}`)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('已标记服务到期')
        this.getActiveList()
      }).catch(() => {})
    },
    onOperatorChange (val) {
      const op = this.employeeList.find(o => o._id === val)
      this.acceptForm.operatorName = op ? op.name : ''
    },
    // 延期（已到期 tab 操作；仅自然到期行展示。EXPIRED → ACTIVE + 新结束日期，门店/平台/负责人同步恢复）
    openExtendDialog (row) {
      this.extendForm = {
        termId: row._id,
        projectName: row.project && row.project.projectName,
        serviceStartDate: row.serviceStartDate,
        serviceEndDate: row.serviceEndDate,
        newEndDate: '',
        reason: ''
      }
      this.extendDialogVisible = true
    },
    async submitExtend () {
      if (!this.extendForm.newEndDate) return this.$message.warning('请选择新服务结束日期')
      if (!String(this.extendForm.reason).trim()) return this.$message.warning('请填写延期原因')
      // 按当天 23:59:59 提交，避免"选今天"被后端"晚于当前时间"校验拒绝
      const payload = {
        serviceEndDate: `${this.extendForm.newEndDate} 23:59:59`,
        reason: String(this.extendForm.reason).trim()
      }
      this.extendSaving = true
      try {
        const { data: res } = await this.$http.put(`proxy/extend/${this.extendForm.termId}`, payload)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('已延期，服务期恢复为服务中')
        this.extendDialogVisible = false
        this.getExpiredList()
      } catch (e) {
        this.$message.error('延期失败')
      } finally {
        this.extendSaving = false
      }
    },
    onEditOperatorChange (val) {
      const op = this.employeeList.find(o => o._id === val)
      this.editForm.operatorName = op ? op.name : ''
    },
    openAcceptDialog (row) {
      this.acceptForm = this.emptyForm()
      this.acceptForm.termId = row._id
      this.acceptForm.projectName = row.project && row.project.projectName
      this.acceptForm.packageType = row.packageType || ''
      // 预填移交评估单量
      if (Array.isArray(row.estimatedVolumes)) {
        row.estimatedVolumes.forEach(v => {
          const p = this.acceptForm.platforms.find(pp => pp.platform === v.platform)
          if (p) p.targetVolume = v.volume
        })
      }
      this.groupOptions = []
      this.searchGroups('')
      this.acceptDialogVisible = true
    },
    async submitAccept () {
      if (!this.acceptForm.operatorId) return this.$message.warning('请选择接收运营师')
      if (!this.acceptForm.serviceDateRange || this.acceptForm.serviceDateRange.length !== 2) return this.$message.warning('请选择服务时间')
      const payload = {
        ...this.acceptForm,
        serviceStartDate: this.acceptForm.serviceDateRange[0],
        serviceEndDate: this.acceptForm.serviceDateRange[1]
      }
      delete payload.serviceDateRange
      try {
        const { data: res } = await this.$http.post(`proxy/accept/${this.acceptForm.termId}`, payload)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        // 后端返回 groupBound:false 表示接收成功但绑群失败，给降级提示（warning 而非 success）
        if (res.data && res.data.groupBound === false) {
          this.$message.warning(res.meta.msg)
        } else {
          this.$message.success('接收成功')
        }
        this.acceptDialogVisible = false
        this.getPendingList()
      } catch (e) {
        this.$message.error('接收失败')
      }
    },
    async openDetailDialog (row) {
      const { data: res } = await this.$http.get(`proxy/detail/${row._id}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.detailData = res.data
      this.detailDialogVisible = true
    },
    async openEditDialog (row) {
      const { data: res } = await this.$http.get(`proxy/detail/${row._id}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      const d = res.data
      const startDate = d.term.serviceStartDate ? this.$getDate(d.term.serviceStartDate) : ''
      const endDate = d.term.serviceEndDate ? this.$getDate(d.term.serviceEndDate) : ''
      this.editForm = {
        termId: row._id,
        projectName: d.project && d.project.projectName,
        packageType: d.term.packageType || '',
        serviceDateRange: (startDate && endDate) ? [startDate, endDate] : [],
        operatorId: '',
        operatorName: d.currentOperator ? d.currentOperator.employeeName : '',
        platforms: ['meituan', 'eleme', 'jd'].map(p => {
          const found = (d.platforms || []).find(pp => pp.platform === p)
          return { platform: p, code: found ? found.code : '', storeName: found ? found.storeName : '', targetVolume: found ? found.targetVolume : null }
        })
      }
      this.editDialogVisible = true
    },
    async submitEdit () {
      const payload = { ...this.editForm }
      if (this.editForm.serviceDateRange && this.editForm.serviceDateRange.length === 2) {
        payload.serviceStartDate = this.editForm.serviceDateRange[0]
        payload.serviceEndDate = this.editForm.serviceDateRange[1]
      }
      delete payload.serviceDateRange
      try {
        const { data: res } = await this.$http.put(`proxy/modify/${this.editForm.termId}`, payload)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('修改成功')
        this.editDialogVisible = false
        this.getActiveList()
      } catch (e) {
        this.$message.error('修改失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-bar {
  margin-bottom: 10px;
  padding: 20px;
  padding-bottom: 0;
  background-color: #f5f7fa;
  border-radius: 4px;
}
.bold { font-weight: bold; color: #000; }
.text-content { font-size: 12px; color: #909399; }
.text { font-size: 14px; color: #66666d; }
.cardHeader { font-size: 16px; font-weight: bold; }
/* 历史服务期时间线中当前查看期的高亮行 */
/deep/ .el-table .current-term-row {
  background: #f0f9eb;
}
</style>
